import React, { useState, useEffect } from 'react';
import Pagination_ from '@mui/material/Pagination';
import '../styles.scss';


const TablePagination = ({ data, changePage, changeItensPerPage }) => {

  const [inputPagination, setInputPagination] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(false);

  const changeInputPagination = (page) => {
    setInputPagination(page);
    if (page != "") {
      changePage(page);
      setCurrentPage(page);
    }
  }

  const handlechangeItensPerPge = (amount) => {
    if (changeItensPerPage !== undefined) {
      changeItensPerPage(amount)
    }
  }

  useEffect(() => {
    if (changeItensPerPage !== undefined)
      setItensPerPage(true);
      
    setInputPagination(data.page);
    setCurrentPage(data.page);
  }, [data.page])

  const handleChange = (e, p) => {
    changePage(p)
  }

  const qtdInicial = (pageSize, page) => {
    let quantidade = ' ';
    if (pageSize && page) quantidade = (pageSize * page) - (pageSize - 1);
    return ` ${quantidade} `;
  }

  const qtdFinal = (pageSize, page) => {
    let quantidade = ' ';
    if (pageSize && page) {
      if (data.lista.length < pageSize) {
        quantidade = data.totalCount
      } else {
        quantidade = pageSize * page;
      }
    }
    return ` ${quantidade} `;
  }

  return (
    <>
      <div className='PaginationContainer'>
        <div className='row'>
          <div className='col-12 mt20' style={{ marginRight: "120px" }}>
            Mostrando
            {qtdInicial(data.pageSize, data.page)}
            até
            {qtdFinal(data.pageSize, data.page)}
            de {data.totalCount} registros
          </div>
        </div>
        <div className='row'>
          <div className="col-12 mt20" style={{ display: "flex" }}>
            <Pagination_ count={data.totalPages} defaultPage={1} variant="outlined" shape="rounded" onChange={handleChange} color="secondary" page={currentPage} />
            <div className="div-iput-page">
              <input className='input-pagination' onChange={(e) => changeInputPagination(e.target.value)} type="number" value={inputPagination} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TablePagination;